import { useMutation } from '@tanstack/react-query';
export const useSaveVisitMutation = () => {
    const saveVisitMutation = useMutation({
        mutationFn: async (url) => {
            await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });
        },
        onError: undefined,
    });
    return { saveVisitMutation };
};
